// CCS-372: the ROTA table's "Notes" column read `latestCareNote[0].note`
// directly, which rendered the literal string "null" when a shift had no note
// (and could throw if the array was ever absent). Safely return the latest note
// text, or an empty string when there is none.
export const getShiftNoteText = (row) =>
  row?.original?.latestCareNote?.[0]?.note ?? "";
